var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section main-section" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("title-comp", { attrs: { name: _vm.$t("title.account_auth") } }),
        _c("div", { staticClass: "form-container form-login" }, [
          _vm.loadingState
            ? _c(
                "div",
                { staticClass: "hourglass-outer" },
                [_c("hourglass")],
                1
              )
            : _c("div", [
                _c("div", { staticClass: "columns is-centered is-vcentered" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("strong", [_vm._v(_vm._s(_vm.$t("placeholder.name")))]),
                  ]),
                  _c("div", { staticClass: "column" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.userProfile.first_name +
                            " " +
                            _vm.userProfile.last_name
                        )
                      ),
                    ]),
                  ]),
                ]),
                _vm.userProfile.email
                  ? _c(
                      "div",
                      { staticClass: "columns is-centered is-vcentered" },
                      [
                        _c("div", { staticClass: "column" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("placeholder.email"))),
                          ]),
                        ]),
                        _c("div", { staticClass: "column" }, [
                          _c("p", [_vm._v(_vm._s(_vm.userProfile.email))]),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "columns is-centered is-vcentered" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("placeholder.password"))),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c("router-link", { attrs: { to: _vm.urlPassword } }, [
                        _vm._v(_vm._s(_vm.$t("button.update_password"))),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }